if (!customElements.get('slg-navigation')) {
  customElements.define('slg-navigation', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const signal = this.abort.signal;
      const menu = this.querySelector('.slg-nav__shop');
      const language = this.querySelector('.slg-nav__language');
      const groups = [menu, language].filter(Boolean);
      const setOpen = (item, open) => { item.open = open; item.querySelector('summary').setAttribute('aria-expanded', String(open)); };
      groups.forEach(item => item.addEventListener('toggle', () => {
        item.querySelector('summary').setAttribute('aria-expanded', String(item.open));
        if (item.open) groups.filter(other => other !== item).forEach(other => setOpen(other, false));
        const anyOpen = groups.some(item => item.open);
        this.closest('.section-header')?.classList.toggle('menu-open', anyOpen);
        const sticky = this.closest('sticky-header');
        if(sticky) sticky.preventHide = anyOpen;
      }, {signal}));
      menu.addEventListener('pointerenter', event => { if(event.pointerType === 'mouse' && innerWidth >= 990) { clearTimeout(this.closeTimer); setOpen(menu, true); } }, {signal});
      menu.addEventListener('pointerleave', event => { if(event.pointerType === 'mouse' && innerWidth >= 990) this.closeTimer = setTimeout(() => { if(!menu.contains(document.activeElement)) setOpen(menu, false); }, 160); }, {signal});
      this.addEventListener('keydown', event => { if(event.key === 'Escape') { const item = groups.find(item => item.open); if(item) { event.preventDefault(); setOpen(item, false); item.querySelector('summary').focus(); } } }, {signal});
      document.addEventListener('pointerdown', event => { if(!this.contains(event.target)) groups.forEach(item => setOpen(item, false)); }, {signal});
      this.addEventListener('focusout', event => { if(event.relatedTarget && !this.contains(event.relatedTarget)) groups.forEach(item => setOpen(item, false)); }, {signal});
      document.addEventListener('shopify:block:select', event => { if(this.contains(event.target)) setOpen(menu, true); }, {signal});
    }
    disconnectedCallback() { this.abort?.abort(); clearTimeout(this.closeTimer); }
  });
}
